import { render, staticRenderFns } from "./extended.vue?vue&type=template&id=ca59e268&scoped=true&"
import script from "./extended.vue?vue&type=script&lang=js&"
export * from "./extended.vue?vue&type=script&lang=js&"
import style0 from "./extended.vue?vue&type=style&index=0&id=ca59e268&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca59e268",
  null
  
)

export default component.exports